module.exports = __webpack_public_path__ + "img/tema-3-9.74d9779b.svg";